import { z } from "zod";
import { MOOD_OPTIONS, type MoodOptionId } from "@/shared/pulse/mood/mood-display";

const moodOptionIds = MOOD_OPTIONS.map((option) => option.id) as [MoodOptionId, ...MoodOptionId[]];

/// Wire mirrors of the shore self check-in DTOs (spec 3.2).
export const SELF_CHECK_IN_AVAILABILITIES = ["available", "in_progress", "done_today"] as const;
export const selfCheckInAvailabilitySchema = z.enum(SELF_CHECK_IN_AVAILABILITIES);
export type SelfCheckInAvailability = z.infer<typeof selfCheckInAvailabilitySchema>;

export const selfCheckInOverviewSchema = z
  .object({
    availability: selfCheckInAvailabilitySchema,
    deliveryId: z.string().nullable(),
    questionsSnapshot: z.unknown(),
    templateVersion: z.number().int(),
    respondedQuestionIndexes: z.array(z.number().int()),
    isAnonymous: z.boolean().nullable(),
    expiresAt: z.string().nullable(),
    /// Mood picked today + consecutive-day streak (mood orb CTA). Optional
    /// so the mirror tolerates a shore that predates the fields.
    todayMood: z.enum(moodOptionIds).nullable().optional(),
    streakDays: z.number().int().min(0).optional(),
  })
  .strict();
export type SelfCheckInOverview = z.infer<typeof selfCheckInOverviewSchema>;

export const startSelfCheckInResponseSchema = z
  .object({
    deliveryId: z.string(),
    runId: z.string(),
    questionsSnapshot: z.unknown(),
    expiresAt: z.string(),
  })
  .strict();
export type StartSelfCheckInResponse = z.infer<typeof startSelfCheckInResponseSchema>;

export const startSelfCheckInRequestSchema = z
  .object({
    mood: z.enum(moodOptionIds),
    followUpText: z.string().optional(),
  })
  .strict();
export type StartSelfCheckInRequest = z.infer<typeof startSelfCheckInRequestSchema>;
